import { render } from "./CarouselSection.vue?vue&type=template&id=676e078c&scoped=true"
import script from "./CarouselSection.vue?vue&type=script&lang=js"
export * from "./CarouselSection.vue?vue&type=script&lang=js"

import "./CarouselSection.vue?vue&type=style&index=0&id=676e078c&lang=sass&scoped=true"

import exportComponent from "../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-676e078c"]])

export default __exports__